import type { JSTLocalPrefsApi } from "@indeed/tare/localPrefs/JSTLocalPrefs";

import { recordNpsTrigger } from "./recordNpsTrigger";

export const NPS_VIEWJOB_TRIGGER_NAMESPACE = "JobsearchFeedback";
export const NPS_VIEWJOB_TRIGGER_KEY = "NpsViewjobTriggerTimestamp";
// 30-min TTL so a stale View Job open can't fire NPS on a much later visit.
export const VIEWJOB_TRIGGER_TTL_MS = 30 * 60 * 1000;

// Log/attribution value shared with the reader (useNpsDisplayEligibility).
export const NPS_VIEWJOB_TRIGGER_VALUE = "viewjob_engagement";

/**
 * Records a View Job engagement NPS trigger so the Homepage or SERP can later
 * show the survey (DISCO-5522). Mirrors `recordNpsSaveTrigger`.
 * Best-effort so a failed write never blocks View Job rendering.
 */
export function recordNpsViewjobTrigger(localPrefs: JSTLocalPrefsApi): Promise<void> {
  return recordNpsTrigger(localPrefs, NPS_VIEWJOB_TRIGGER_NAMESPACE, NPS_VIEWJOB_TRIGGER_KEY);
}
